<!-- page wrapper -->
<div class="action-prevented-dialog-wrapper">
    <mat-card class="action-prevented-card">
        <!-- header -->
        <mat-card-header class="action-prevented-header">
            <!-- title -->
            <div class="action-prevented-title">Action Prevented</div>
        </mat-card-header>
        <!-- content -->
        <div class="action-prevented-content">
            <mat-icon>block</mat-icon>
            <p>The action you took requires a valid login</p>
            <p>either <a (click)="login($event)">LOGIN</a> for further access or go <a (click)="home($event)">Home</a>
                to view the
                jobs</p>
        </div>
    </mat-card>
</div>